<template>
  <!-- PC 개발범위 -->
  <div class="w-full new_lg:flex flex-col hidden items-center bg-white py-16">
    <div class="max-w-7xl w-full flex flex-col gap-16 items-center px-8">
      <!-- Title -->
      <h2 class="font-bold text-3xl text-text-0 text-center">
        개발범위
      </h2>

      <!-- Cards Container -->
      <div class="w-full max-w-[1060px] grid grid-cols-4 gap-5">
        <div v-for="card in cards" :key="card.id" class="bg-white rounded-2xl card-item">
          <div class="flex flex-col items-center p-6 pb-10 gap-4">
            <!-- Illustration -->
            <div class="h-32 w-full flex items-center justify-center">
              <img :src="card.image" :alt="card.alt" class="h-full">
            </div>

            <!-- Text Content -->
            <div class="flex flex-col gap-3 items-center text-center">
              <h3 class="font-semibold text-2xl leading-normal text-text-0">
                {{ card.heading }}
              </h3>
              <p class="text-lg leading-relaxed text-text-1" v-html="card.description"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 모바일 개발범위 -->
  <div class="w-full flex flex-col items-center bg-white pt-10 new_lg:hidden">
    <!-- Title -->
    <h2 class="font-bold text-2xl text-text-0 text-center">
      개발범위
    </h2>

    <!-- Cards Container - 가로 스크롤 -->
    <div class="w-full overflow-x-auto scrollbar-hide">
      <div class="flex gap-3 pb-4">
        <div v-for="(card, index) in cards" :key="card.id"
             :class="['flex-shrink-0 w-[255px] h-[333px] bg-white rounded-2xl card-item mt-7 mb-10', index === 0 ? 'ml-5' : '']">
          <div class="flex flex-col items-center pt-6 px-4 pb-8 gap-4">
            <!-- Illustration -->
            <div class="h-32 w-full flex items-center justify-center">
              <img :src="card.image" :alt="card.alt" class="h-full">
            </div>

            <!-- Text Content -->
            <div class="flex flex-col gap-3 items-center text-center mt-4">
              <h3 class="font-semibold text-xl leading-normal text-text-0">
                {{ card.heading }}
              </h3>
              <p class="text-sm leading-relaxed text-text-1 break-keep" v-html="card.description"></p>
            </div>
          </div>
        </div>
        <div class="w-2 h-1 shrink-0" />
      </div>
    </div>
  </div>
</template>

<script setup>
import icWeb from '@/assets/ic-development-web.svg'
import icMobile from '@/assets/ic-development-mobile.svg'
import icWearable from '@/assets/ic-development-wearable.svg'
import icIot from '@/assets/ic-development-iot.svg'

const cards = [
  {
    id: 1,
    title: 'Web',
    image: icWeb,
    alt: 'Web Development',
    heading: '웹 개발',
    description: '반응형 UI/UX 기반의 웹 서비스를 설계·개발하며 다양한 환경에서 일관된 사용자 경험을 제공합니다.'
  },
  {
    id: 2,
    title: 'Mobile',
    image: icMobile,
    alt: 'Mobile Development',
    heading: '앱 개발',
    description: 'iOS/Android 네이티브 및 크로스플랫폼 앱을 개발하며, 기능과 퍼포먼스를 최적화합니다.'
  },
  {
    id: 3,
    title: 'Wearable',
    image: icWearable,
    alt: 'Wearable Development',
    heading: '클라우드 & 인프라',
    description: 'AWS/GCP 기반 인프라 설계,  CI/CD 구축을 통해 확장성과 안정성을 갖춘 운영 환경을 제공합니다.'
  },
  {
    id: 4,
    title: 'IoT',
    image: icIot,
    alt: 'IoT Development',
    heading: '유지보수 및 지원',
    description: '기능 개선, 오류 수정, 장애 대응, 성능 최적화 등 서비스 안정적 운영을 위한 전반적인 기술 지원을 제공합니다.'
  }
]
</script>

<style scoped>
/* 스크롤바 숨기기 */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.card-item {
  box-shadow: 0px 4px 20px 0px #00000026;
}
</style>